<template>
  <div id="myContainer" >
    <slot></slot>
  </div>
</template>

<script>
export default {
};
</script>

<style>
#myContainer{
  margin:0.9%;
}
</style>